module.exports = __webpack_public_path__ + "static/media/Graphics_4.df50af22.png";